package features.videoDetails.data.model

import kotlinx.serialization.Serializable

@Serializable
data class AddAllFavorites(
    val videos: List<FavoriteEntity>
)
